// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_2itJT","languageText":"index_languageText_3CpaG"};